import { DefaultTheme } from 'styled-components';

declare module 'styled-components' {
  export interface DefaultTheme {
    palette: {
      burgundy: string;
      equifaxRed: string;
      toolTipBackground: string;
      purple: string;
      orangeWarning: string;
      palePurple: string;
      palePurpleTwo: string;
      vibrantPurple: string;
      vibrantPurpleTwo: string;
      green: string;
      lightGreen: string;
      grey: string;
      danger: string;
      blue: string;
      infoBlue: string;
      cornflowerBlue: string;
      amethyst: string;
      lightPink: string;
      lightGrey: string;
      lightGreyTwo: string;
      lightGreyThree: string;
      lightGreyFive: string;
      lightGreySix: string;
      lightGreySeven: string;
      lightGreyEight: string;
      lightGreyShade: string;
      middleBluePurple: string;
      darkGrey: string;
      darkGreyTwo: string;
      darkGreyThree: string;
      darkGrayThree: string;
      darkGrayFour: string;
      darkGrayFive: string;
      disabledGrey: string;
      lightBlue: string;
      deepBlueTwo: string;
      backgroundPink: string;
      white: string;
      lilyWhite: string;
      whiteSmoke: string;
      cream: string;
      teal: string;
      background: string;
      darkCyan: string;
      darkGray: string;
      dustyGray: string;
      gray: string;
      lightGray: string;
      lightGrayTwo: string;
      lightGrayThree: string;
      lightGrayFour: string;
      lightGrayFive: string;
      basicGrayTwo: string;
      basicGray: string;
      basicGrayThree: string;
      basicGrayFour: string;
      mediumGray: string;
      backgroundGray: string;
      sortIndicatorGray: string;
      tableRowGray: string;
      translucentPurple: string;
      translucentPink: string;
      transparent: string;
      darkRed: string;
      dusty: string;
      dustyTwo: string;
      asphalt: string;
      wetAsphalt: string;
      grayTwo: string;
      grayThree: string;
      black: string;
      yellow: string;
      leaseColor: string;
      warning: string;
      warningLight: string;
      warningText: string;
      success: string;
      warmed: string;
      lightPurple: string;
      lightPurpleTwo: string;
      lightPurpleThree: string;
      lightPurpleFour: string;
      lightPurpleFive: string;
      lightPurpleSix: string;
      lightPurpleSeven: string;
      lightPurpleEight: string;
      lightPurpleNine: string;
      lightPurpleTen: string;
      lightPurpleEUI: string;
      lilac: string;
      lightYellow: string;
      darkBlue: string;
      powderBlue: string;
      skyBlue: string;
      linkColor: string;
      rebeccaPurple: string;
      darkPurple: string;
      darkPurpleTwo: string;
      darkPurpleThree: string;
      darkPurpleFour: string;
      darkPurpleFive: string;
      darkPurpleSix: string;
      darkPurpleEUI: string;
      borderPurple: string;
      amethystPutple: string;
      hightLightPurple: string;
      deepBlue: string;
      blackOlive: string;
      brightOrange: string;
      silver: string;
      purpleTwo: string;
      purpleThree: string;
      purpleFour: string;
      purpleFive: string;
      purpleSix: string;
      purpleSeven: string;
      purpleEight: string;
      warningTwo: string;
      red: string;
      toastSuccess: string;
      toastError: string;
      toastInfo: string;
      toastWarning: string;
      newCarCardGradient: {
        from: string;
        to: string;
      };
      appHeaderGradient: {
        from: string;
        to: string;
      };
      sidebarGradient: {
        from: string;
        to: string;
      };
      text: {
        primary: string;
        white: string;
        purple: string;
        green: string;
        gray: string;
        lightBlue: string;
        basicGrey: string;
        darkGrey: string;
        dusty: string;
      };
      vehiclePreferencesTableBackground: string;
      vehiclePreferencesTableBackgroundHovered: string;
      vehiclePreferencesGrayOutButtonColor: string;
      trimSelectedBackground: string;
      pinkCharm: string;
      malberry: string;
      raisinBlack: string;
      charcoalBlack: string;
      lavender: string;
      lavenderBlush: string;
      gainsboro: string;
      fordMake: string;
    };
    typography: {
      fontFamily: string;
      fontSize: number;
      normalFontStyle: string;
      fontSize30: number;
      fontSize28: number;
      fontSize26: number;
      fontSize24: number;
      fontSize21: number;
      fontSize16: number;
      fontSize20: number;
      fontSize14: number;
      fontSize12: number;
      fontSize11: number;
      fontSize10: number;
      h1: number;
      h2: number;
      h3: number;
      h4: number;
      h5: number;
      h6: number;
      fontWeights: {
        hairline: number;
        thin: number;
        light: number;
        normal: number;
        medium: number;
        semibold: number;
        bold: number;
        extrabold: number;
        black: number;
        zero: number;
      };
      info: number;
    };
  }
}
export const theme: DefaultTheme = {
  palette: {
    burgundy: '#802968',
    basicGrayTwo: '#eee',
    basicGrayThree: '#aeacac',
    basicGrayFour: '#A4A2A2',
    equifaxRed: '#B32541',
    blue: '#428BCA',
    infoBlue: '#28A6D7',
    cornflowerBlue: '#337ab7',
    amethyst: '#9972c9',
    green: '#41C064',
    lightGreen: '#F0FFE0',
    darkGrey: '#a5a5a7',
    grey: '#565656',
    danger: '#C9112C',
    white: '#FFFFFF',
    whiteSmoke: '#F1F1F1',
    lilyWhite: '#e7f8ff',
    skyBlue: '#64d0ff',
    cream: '#ffffca',
    purple: '#7529A5',
    toolTipBackground: '#331C54',
    orangeWarning: '#F08A21',
    vibrantPurple: '#E0BDFF',
    vibrantPurpleTwo: '#af7fe7',
    teal: '#72AEB4',
    lightGreyFive: '#f5f5f5',
    palePurple: '#B4A5CA',
    lilac: '#dbceec',
    palePurpleTwo: '#c3b7d1',
    lightPurpleTwo: '#f5effe',
    lightPurpleThree: '#775b9b',
    lightPurpleFour: '#dbceec',
    lightPurpleFive: '#f1ebf7',
    lightPurpleSix: '#e7def1',
    lightPurpleSeven: '#cebde4',
    lightPurpleEight: '#F6F6F6',
    lightPurpleNine: '#815ca7',
    lightPurpleTen: '#f6f3fa',
    lightPink: '#F6F3Fe',
    lightGrey: '#CCCCCC',
    lightGreyTwo: '#BBBBBB',
    lightGreyThree: '#717171',
    lightGrayFour: '#b6b7be',
    lightGreyShade: '#dfdfdf',
    middleBluePurple: '#8A75B4',
    disabledGrey: '#D8D8D8',
    backgroundPink: '#F3EBFF',
    background: '#E5E5E5',
    darkCyan: '#00928F',
    darkGray: '#454545',
    darkGreyTwo: '#6e7880',
    darkGreyThree: '#969696',
    darkGrayThree: '#b7b7b7',
    darkGrayFour: '#7E7E7E',
    darkGrayFive: '#4D4D4F',
    dustyGray: '#545454',
    gray: '#F0F0F0',
    lightGray: '#EFEFEF',
    lightGrayTwo: '#AAAAAA',
    lightGrayThree: '#EFEFEF',
    lightGrayFive: '#dcdcdc',
    lightGreySix: '#f5f4f7',
    lightGreySeven: '#dadada',
    lightGreyEight: '#d0d0d0',
    mediumGray: '#565656',
    lightBlue: '#83A3BE',
    deepBlueTwo: '#0A72CB',
    basicGray: '#676767',
    backgroundGray: '#DDDDDD',
    sortIndicatorGray: '#9B9B9B',
    tableRowGray: '#F7F7F7',
    translucentPurple: '#775CA3',
    translucentPink: '#F9F9F9',
    transparent: 'transparent',
    darkRed: '#B22222',
    dusty: '#999999',
    dustyTwo: '#999',
    asphalt: '#4A4A4A',
    wetAsphalt: '#333333',
    grayTwo: '#454545',
    grayThree: '#e0e0e0',
    black: '#000000',
    yellow: '#E1A31F',
    leaseColor: '#249cd1',
    warning: '#EC961C',
    warningLight: '#fcf8e3',
    warningText: '#957843',
    success: '#00AB55',
    warmed: '#D8C51C',
    lightPurpleEUI: '#E0BDFF',
    // TODO - confirm with designers about the value
    darkPurpleEUI: '#8a75b2',
    borderPurple: '#5A3688',
    darkBlue: '#322346',
    powderBlue: '#B6D0E2',
    linkColor: '#0A72CB',
    rebeccaPurple: '#663399',
    lightYellow: '#FFFFE0',
    lightPurple: '#9c8bb3',
    darkPurpleTwo: '#8d819d',
    darkPurple: '#513773',
    amethystPutple: '#885da3',
    darkPurpleThree: '#5b3789',
    darkPurpleFour: '#4f2d79',
    darkPurpleFive: '#3f2665',
    darkPurpleSix: '#4c3178',
    deepBlue: '#0e70c3',
    hightLightPurple: '#240a45',
    blackOlive: '#3A3A3A',
    brightOrange: '#DEAE22',
    silver: '#c6c6c6',
    purpleTwo: '#9875c6',
    purpleThree: '#6A4C90',
    purpleFour: '#6a4a94',
    purpleFive: '#6b449f',
    purpleSix: '#7648ad',
    purpleSeven: '#5E3792',
    purpleEight: '#593487',
    toastSuccess: '#6FB570',
    toastError: '#bd362f',
    toastInfo: '#2f96b4',
    toastWarning: '#f89406',
    newCarCardGradient: {
      from: '#FBF8FF',
      to: '#F6F0FF'
    },
    appHeaderGradient: {
      from: '#68449E',
      to: '#3B1E6C'
    },
    sidebarGradient: {
      from: '#653E97',
      to: '#66359E'
    },
    text: {
      green: '#00AB55',
      primary: '#000000',
      purple: '#593487',
      white: '#FFFFFF',
      gray: '#4F4F4F',
      lightBlue: '#0A72CB',
      basicGrey: '#676767',
      darkGrey: '#333333',
      dusty: '#999999'
    },
    vehiclePreferencesTableBackground: '#FBEEF1',
    vehiclePreferencesTableBackgroundHovered: '#F4DADF',
    vehiclePreferencesGrayOutButtonColor: '#E4E4E4',
    trimSelectedBackground: '#513E6D',
    pinkCharm: '#d17b8c',
    malberry: '#973490',
    raisinBlack: '#212121',
    charcoalBlack: '#272727',
    lavender: '#D1C7E0',
    lavenderBlush: '#F5EFFF',
    gainsboro: '#DBDDD8',
    warningTwo: '#F5A623',
    red: '#cc0000',
    fordMake: '#003478'
  },
  typography: {
    fontFamily: 'proxima-nova',
    fontSize: 14,
    normalFontStyle: 'normal',
    fontSize30: 30,
    fontSize28: 28,
    fontSize26: 26,
    fontSize24: 24,
    fontSize16: 16,
    fontSize20: 20,
    fontSize14: 14,
    fontSize12: 12,
    fontSize11: 11,
    fontSize10: 10,
    h1: 24,
    fontSize21: 21,
    h2: 20,
    h3: 18,
    h4: 16,
    h5: 14,
    h6: 12,
    fontWeights: {
      hairline: 100,
      thin: 200,
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 600,
      extrabold: 700,
      black: 700,
      zero: 0
    },
    info: 40
  }
};
